import {
  call,
  CallEffect,
  put,
  PutEffect,
  takeLatest,
} from '@redux-saga/core/effects';
import { UserPreferences } from 'models';
import { AnyAction } from 'redux';
import UserService from 'services/userServices';
import USER_PREFERENCES_ACTION, {
  userPreferencesTypes,
} from '../actions/userPreferencesAction';
import BaseAction from '../actions/baseAction';

interface IUserPreferences {
  data: UserPreferences;
  status: number;
}

export function* getUserPreferences(action: {
  userId: string;
  type: string;
}): Generator<
  CallEffect<IUserPreferences> | PutEffect<AnyAction>,
  void,
  IUserPreferences
> {
  try {
    const result: IUserPreferences = yield call(
      UserService.getPreferences,
      action.userId,
    );
    yield put(USER_PREFERENCES_ACTION.getUserPreferencesSuccess(result.data));
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_USER_PREFERENCES ${error}`,
      }),
    );
  }
}

export const watchUserPreferences = [
  takeLatest(userPreferencesTypes.GET_USER_PREFERENCES, getUserPreferences),
];
